import { Showroom } from "../components/showroom.vue";
Vue.component("showroom", Showroom);